import { z } from "zod";

export const EtlIgnoredSchema = z.object({
	etl_ignored: z.string()
});

export type EtlIgnored = z.infer<typeof EtlIgnoredSchema>;
